export default "__VITE_ASSET__IpdztMPQ__"